import { Configuration, PopupRequest } from "@azure/msal-browser"

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: "43604759-c5e1-4c75-98d9-33a5aa9c2d82",
        authority: "https://salarysystem.b2clogin.com/salarysystem.onmicrosoft.com/B2C_1_susi",
        redirectUri: "/",
        postLogoutRedirectUri: "/login",
        knownAuthorities: ["salarysystem.b2clogin.com"]
    },
    cache: {
        cacheLocation: 'localStorage', // Persists tokens across browser sessions for SSO
        // Stores only the transient auth-flow state (state/nonce) in a short-lived
        // Secure cookie — never tokens. Lets the silent iframe flow survive Chrome's
        // third-party cookie blocking on b2clogin.com.
        storeAuthStateInCookie: true,
    },
    system: {},
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["https://salarysystem.onmicrosoft.com/salarysystem-d-api/access_as_user"],
}

// Redirect URI used only by the hidden iframe that acquireTokenSilent spins up.
// Pointing this at a minimal blank page prevents MSAL's block_iframe_reload error,
// which fires when the iframe navigates back to "/" and bootstraps the full SPA.
export const silentRedirectUri = "/blank.html"

